module.exports = __webpack_public_path__ + "static/headerBg.61a8724f.svg";


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/NetworksPage/headerBg.svg
// module id = 843
// module chunks = 0